import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/default.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const TitleSmallDouble = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlnsa="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
        x="0px"
        y="0px"
        width="120px"
        height="8.8px"
        viewBox="0 0 120 8.8"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <path
                fill={color}
                d="M118.7,0.6c-0.1,0-0.3-0.2-0.3-0.2c-0.2,0.1-0.3,0-0.4-0.1c-0.2-0.3-0.6-0.1-0.9-0.2c-0.4,0.4-0.7,0-1.1,0
		c-0.2,0.1-0.5,0.2-0.7,0.1c-0.6-0.2-1.1-0.1-1.7-0.1c-0.4,0-0.6,0-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.6c-0.7-0.4-1.4-0.4-2.2-0.2
		c-0.2-0.1-0.3-0.2-0.4-0.3c-0.2,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.5,0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.5,0.1-0.9,0.2-1.2,0.1
		c-0.6-0.1-1.2,0-1.8,0c-0.6,0-1.3,0.2-1.7-0.1c-0.3,0-0.5,0.1-0.7,0.1c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0.2-0.4,0.3-0.8,0.2
		c-0.2-0.1-0.5-0.1-0.7-0.2c-0.4,0-0.8-0.1-0.9,0.2c-0.3-0.1-0.6-0.2-0.9-0.3c-0.2,0.1-0.3,0.2-0.5,0.4C99,0.3,99,0.2,98.9,0.1
		c-0.4,0-0.7,0-0.6,0.2c-0.3,0-0.5,0-0.7,0c-0.2,0-0.4,0.1-0.5,0c-0.4-0.1-0.8-0.3-1.3,0c0,0-0.1,0-0.2,0c-0.3-0.1-0.7,0-1-0.1
		c-0.2,0-0.3-0.1-0.5-0.2c-0.5,0.2-0.5,0.2-1.7,0c0,0.1,0,0.2-0.1,0.3c-0.8-0.1-1.6-0.3-2.5,0c-0.6-0.2-1.4,0.2-1.8-0.2
		c-0.3,0.1-0.5,0.1-0.8,0.2c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1,0.1-0.2,0.2-0.2,0.2c-0.5,0-0.8-0.1-1.2-0.1c-0.4,0-0.8,0.1-1.1-0.1
		c-0.1,0-0.3-0.1-0.4-0.1c0,0.1-0.1,0.2-0.1,0.4c-0.4-0.1-0.8-0.2-1.2-0.2c0,0-0.1,0-0.2,0c-0.2,0.1-0.4,0.2-0.6,0.3
		c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3,0-0.5,0.1-0.7,0.1c-0.2,0-0.3-0.1-0.4-0.2c-0.3,0.1-0.6,0.2-0.8,0.2c-1-0.1-2.1,0-3.1-0.1
		c-0.1,0-0.3,0-0.4,0c-0.7,0.3-1.4,0-2,0.1c-0.5-0.4-0.8,0-1.1,0.2c-0.4-0.3-0.8-0.4-1.3-0.1c-0.1,0-0.2,0.1-0.3,0
		c-0.5-0.1-0.9,0.1-1.3,0.3C70.1,0.5,70,0.3,70,0.3c-0.6,0.1-1.2,0-1.8,0c-0.8,0-1.5,0.2-2.3,0.1c-0.5,0.2-0.9,0-1.3-0.1
		c-0.2,0-0.4-0.1-0.5,0c-0.4,0.4-0.8,0.1-1.1,0c-0.7,0.2-0.8,0.2-0.9-0.2c-0.2,0.2-0.4,0.3-0.5,0.5c-0.4-0.3-1.2,0.1-1.6-0.3
		c-0.1,0.1-0.2,0.3-0.3,0.4c-0.4-0.2-0.7-0.3-1-0.5c-0.6,0.3-1.2,0-1.8,0.1c0,0.1,0,0.1,0,0.2c-0.6,0.1-1,0-1.3-0.3
		c-0.3,0.1-0.6,0.4-1,0.2c-0.6-0.2-0.6,0.1-0.9,0.3c-0.3-0.2-0.5-0.5-1-0.1c-0.2-0.1-0.3-0.2-0.4-0.4c-0.3,0.1-0.5,0.2-0.7,0.2
		c-0.1-0.1-0.2-0.1-0.2-0.2c-0.3,0.1-0.6,0.2-0.9,0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2,0.1-0.3,0.2-0.6,0.4c-0.1-0.1-0.2-0.2-0.3-0.4
		c-0.5,0.3-1.1,0.3-1.6,0.2c-0.7-0.2-1.4-0.1-2,0c-0.3,0-0.6,0-0.9-0.1c-0.4-0.1-0.5,0.2-0.8,0.1c-0.1-0.1-0.3-0.2-0.4-0.3
		c-0.3,0.1-0.5,0.2-0.8,0.4c-0.4-0.1-0.7-0.2-1-0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0-0.3,0-0.5,0c-0.2,0-0.4,0-0.6,0
		c-0.4-0.1-0.8-0.2-1.1,0.1c-0.5-0.2-1.1,0.1-1.5-0.2c-0.2-0.1-0.4-0.1-0.5,0c-0.1,0.2-0.3,0.1-0.5,0.2c-0.1,0-0.2,0.1-0.4,0.2
		c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.2-0.1-0.2-0.1c-0.2,0-0.3,0.1-0.4,0.1c-0.3,0-0.6-0.1-0.9-0.1c-0.5,0-0.8,0.1-1,0.4
		c0,0-0.1,0-0.2,0.1c0-0.2,0-0.3,0-0.5c-0.3,0-0.5,0.1-0.7,0.1c-0.2,0-0.4,0.1-0.5,0C32,0.3,32,0.2,31.8,0.1
		c-0.3,0.1-0.5,0.2-0.8,0.4c-0.3,0-0.6,0-0.9-0.1c-0.7-0.1-0.7-0.2-1.1,0.2c-0.3-0.3-0.7-0.3-1.1-0.2c-0.3,0.1-0.6,0-0.9,0
		c-0.4,0-0.8-0.1-1.2,0c-0.3,0.1-0.5,0-0.7-0.1c-0.4-0.1-0.6-0.1-0.7,0.2c-0.8,0.2-1.4-0.3-2.2-0.3c0.1,0.1,0.1,0.2,0.2,0.3
		c-0.6,0.1-0.9-0.1-1.1-0.3c-0.4,0.2-0.5,0.2-1,0.1c-0.1,0-0.2,0-0.2,0c-0.3,0.2-0.6,0.1-0.9,0c-0.1-0.1-0.5,0-0.6,0
		c-0.1,0.2-0.5,0.1-0.6,0.1c-0.4,0.3-0.6-0.1-0.9,0c-0.3,0.1-0.6,0.2-1,0c-0.2-0.1-0.7,0-1.1,0c-0.5,0.1-0.8-0.1-1.2-0.2
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3,0.4-0.8,0.3-1.3,0.2c-0.2-0.1-0.4-0.1-0.7-0.1C11,0.3,11,0.4,11.1,0.5
		c-0.4,0-0.8,0-0.9-0.1c-0.4-0.3-0.7-0.2-1.1,0C8.7,0.5,8.1,0.5,7.7,0.5C7.4,0.5,7.2,0.3,7,0.2C6.6,0.5,6.2,0.6,5.9,0.5
		c-0.5-0.1-1.5-0.1-2-0.1c-0.4,0.1-0.6,0-0.7-0.2c0,0-0.1,0-0.2-0.1c0,0.1,0,0.2,0,0.3C2.3,0.4,1.7,0.3,1.3,0.3
		C1,0.4,0.8,0.5,0.6,0.6C0.4,0.8,0,0.9,0,1l0.7,0.2c0.4,0,1.1,0.1,1.7,0.1c0-0.1,0-0.2,0-0.3c0.1,0,0.2,0.1,0.2,0.1
		c0.1,0.2,0.4,0.3,0.8,0.2c0.2,0,0.5,0,0.8,0c0,0,0.1,0,0.2,0c0,0,0,0,0,0c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.7,0,1.1-0.3
		c0.2,0.1,0.5,0.3,0.7,0.3c0.5,0,1.1,0,1.5-0.1c0.5-0.2,0.7-0.3,1.2,0c0.1,0.1,0.6,0.1,0.9,0.1c-0.1-0.1-0.1-0.2-0.2-0.4
		c0.3,0.1,0.5,0.1,0.7,0.1c0.5,0.1,1,0.2,1.3-0.2c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1-0.1,0.2-0.1c0,0.1,0.1,0.2,0.1,0.2
		c0,0,0,0,0,0c0.1,0.1,0.3,0.1,0.5,0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.4,0.1,0.7,0.3,1.2,0.2c0.4-0.1,0.9-0.1,1.1,0c0.4,0.2,0.7,0.1,1,0
		c0.3-0.1,0.5,0.3,0.9,0.1c0.1,0,0.5,0.1,0.6-0.2c0,0,0.1,0,0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0.1,0.1,0.1
		c0,0,0,0.1-0.1,0.1c0.1,0,0.3,0,0.3,0c0.3,0.1,0.6,0.3,0.9,0c0,0,0.2,0,0.2,0c0.6,0,0.7,0,1.1-0.1c0.2,0.3,0.5,0.5,1.2,0.4
		c-0.1-0.1-0.1-0.2-0.2-0.3c0.8,0,1.4,0.5,2.3,0.3c0.1-0.2,0.3-0.3,0.7-0.2c0.2,0.1,0.5,0.1,0.7,0.1c0.4-0.1,0.8-0.1,1.2,0
		c0.3,0,0.6,0.1,0.9,0c0.4-0.1,0.8-0.1,1.1,0.2c0.4-0.3,0.4-0.3,1.2-0.2c0.3,0.1,0.6,0.1,0.9,0.1c0.3-0.1,0.6-0.3,0.8-0.4
		c0.1,0.2,0.2,0.3,0.3,0.4c0.1,0,0.3,0,0.5,0c0.2,0,0.4-0.1,0.7-0.1c0,0.2,0,0.4,0,0.5c0.1,0,0.2,0,0.2-0.1c0.2-0.3,0.4-0.5,1-0.4
		c0.3,0,0.6,0.1,1,0.1c0.1,0,0.3-0.1,0.4-0.1c0,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.2
		c0.2,0,0.4,0,0.5-0.2c0.1-0.2,0.3-0.2,0.5,0c0.4,0.3,1.1,0,1.5,0.2c0.3-0.3,0.7-0.2,1.2-0.1c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.5,0
		c0.1-0.1,0.2-0.2,0.3-0.3c0.4,0.1,0.7,0.2,1.1,0.3c0.2-0.1,0.5-0.2,0.8-0.4c0.2,0.1,0.3,0.2,0.5,0.3c0.4,0.1,0.4-0.3,0.8-0.1
		c0.3,0.1,0.6,0.1,0.9,0.1c0.6-0.1,1.3-0.2,2,0c0.5,0.1,1.1,0.1,1.6-0.2c0.1,0.1,0.2,0.2,0.3,0.4c0.3-0.2,0.4-0.3,0.6-0.4
		c0.1,0.1,0.2,0.2,0.3,0.3c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0.1,0.1,0.2,0.2c0.2-0.1,0.4-0.1,0.8-0.2c0.1,0.1,0.3,0.2,0.4,0.4
		c0,0,0,0,0,0c-0.1-0.1,0-0.3,0-0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.4-0.1,0.5,0.2,0.8,0.3c0.3-0.2,0.3-0.5,0.9-0.3
		c0.5,0.2,0.7-0.2,1-0.2c0.3,0.3,0.8,0.4,1.3,0.3c0-0.1,0-0.1,0-0.2c0.6-0.1,1.3,0.2,1.9-0.1c0.4,0.2,0.7,0.3,1.1,0.5
		c0.1-0.1,0.2-0.3,0.3-0.4c0.5,0.4,1.2-0.1,1.7,0.3c0.2-0.2,0.4-0.3,0.6-0.5c0.1,0.4,0.2,0.5,0.9,0.2c0.4,0.1,0.7,0.4,1.2,0
		c0,0,0.3,0,0.5,0c0.4,0.1,0.7,0.2,1.1,0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0.8,0.2,1.6-0.1,2.4-0.1
		c0.6,0,1.2,0.1,1.9,0c0,0,0.1,0.1,0.2,0.3c0.4-0.2,0.8-0.4,1.3-0.3c0.1,0,0.3,0,0.3,0c0.5-0.3,0.9-0.1,1.3,0.2
		c0.3-0.2,0.6-0.5,1.1-0.2c0.7-0.1,1.4,0.3,2.1-0.1c0.1,0,0.3,0,0.4,0c1.1,0.2,2.1,0.1,3.2,0.1c0.2,0,0.5-0.1,0.8-0.2
		c0.1,0,0.2,0.2,0.4,0.2c0.2,0,0.5-0.1,0.7-0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.2-0.1,0.4-0.2,0.6-0.3c0,0,0.1,0,0.2,0
		c0.4,0.1,0.8,0.2,1.2,0.3c0-0.2,0.1-0.3,0.1-0.4c0.2,0,0.3,0.1,0.4,0.1c0.4,0.2,0.7,0.1,1.2,0.1c0.4,0,0.7,0,1.2,0.1
		c0,0,0.1-0.1,0.2-0.2c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0,0.2,0,0.3-0.1c0,0-0.1-0.1-0.1-0.1c0.2,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0
		c0,0,0.1,0,0.1,0.1c-0.1-0.2,0-0.3,0.4-0.4c0,0.1,0,0.2,0.1,0.4c-0.2,0-0.3,0-0.4,0c0.4,0.3,1.2,0,1.7,0.1c0.9-0.2,1.7-0.1,2.6,0.1
		c0-0.1,0-0.2,0.1-0.3c1.2,0.2,1.2,0.2,1.7,0c0.2,0.1,0.3,0.1,0.5,0.2c0.3,0,0.7-0.1,1,0.1c0,0,0.1,0,0.2,0c0.5-0.3,0.9-0.1,1.3,0
		c0.1,0,0.3,0,0.5,0c0.2,0,0.5,0,0.7,0c0-0.3,0.3-0.3,0.7-0.3c0.1,0.1,0.1,0.2,0.2,0.3c0.2-0.1,0.4-0.2,0.6-0.4
		c0.3,0.1,0.6,0.2,0.9,0.3c0.1-0.3,0.5-0.3,0.9-0.2c0.3,0,0.5,0.1,0.8,0.2c0.4,0.1,0.6,0,0.8-0.2c0.2,0,0.5,0.1,0.7,0.1
		c0.2,0,0.4-0.1,0.7-0.1c0.4,0.4,1.1,0.2,1.8,0.1c0.6,0,1.2-0.1,1.8,0c0.3,0.1,0.7-0.1,1.2-0.1c0,0,0.1,0.1,0.2,0.2
		c0.3-0.1,0.4-0.1,0.5-0.2c0.1,0,0.2-0.1,0.4-0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.8-0.2,1.6-0.2,2.3,0.2c0.1-0.2,0.2-0.4,0.2-0.6
		c0.2,0.2,0.4,0.3,0.8,0.2c0.6,0,1.2-0.1,1.8,0.1c0.2,0.1,0.5-0.1,0.7-0.1c0.1,0,0.3,0,0.4,0.1c0,0,0-0.1,0-0.1
		c0-0.2-0.2-0.4-0.6-0.5c-0.1,0-0.3-0.1-0.4-0.1C118.9,0.5,118.8,0.6,118.7,0.6z M4.8,1.1c-0.4,0.1-0.6,0-0.4-0.3
		C4.6,1,4.7,1.1,4.8,1.1z M7,0.7c-0.1,0-0.1,0-0.2-0.1c0,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0.1,0.2,0.1C7.1,0.7,7,0.7,7,0.7z M9.8,1.1
		c0,0-0.1,0-0.1,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0C9.9,1,9.9,1,9.8,1.1z M11.9,1c-0.1-0.2-0.1-0.2,0.4-0.2
		C12.2,0.9,12.1,0.9,11.9,1z M20.1,1.3c0,0-0.1,0.1-0.2,0.1c0,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.2-0.1C20,1.3,20.1,1.3,20.1,1.3z
		 M21.1,0.7c-0.1,0-0.1-0.1-0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0.1,0.1,0.1,0.2,0.1C21.3,0.7,21.2,0.7,21.1,0.7z M24.9,1.1
		c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.1-0.1-0.1c0,0,0.1-0.1,0.1-0.1C24.8,1.1,24.9,1.1,24.9,1.1z M53.9,1
		c-0.3,0.1-0.4,0-0.3-0.3C53.8,0.9,53.8,1,53.9,1z M68.9,0.9c0.1-0.2,0.3-0.3,0.7-0.2C69.4,0.8,69.3,1,68.9,0.9z"
            />
            <path fill={color} d="M55.2,2.1c-0.1-0.1-0.2-0.1-0.4-0.3C54.8,2.1,54.9,2.2,55.2,2.1z" />
            <path fill={color} d="M70.7,1.9c0.5,0.1,0.5-0.1,0.7-0.2C71,1.6,70.8,1.7,70.7,1.9z" />
            <path
                fill={color}
                d="M12.8,2.3c0.1,0,0.2,0,0.2,0c0-0.1,0-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.1C12.7,2.2,12.7,2.3,12.8,2.3z"
            />
            <path fill={color} d="M11.7,2C11.9,2,12,1.9,12.1,1.8C11.6,1.8,11.6,1.8,11.7,2z" />
            <path
                fill={color}
                d="M9.4,2.2c0.1,0,0.1,0,0.1,0c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0-0.2,0C9.4,2,9.4,2.1,9.4,2.2z"
            />
            <path
                fill={color}
                d="M6.4,1.7c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1C6.5,1.6,6.4,1.6,6.4,1.7z"
            />
            <path
                fill={color}
                d="M21,1.6c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1,0,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1C21.2,1.6,21.1,1.6,21,1.6z"
            />
            <path
                fill={color}
                d="M24.9,2.2c0,0,0.1,0.1,0.1,0.1c0,0,0.1-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1C25,2.1,24.9,2.2,24.9,2.2z"
            />
            <path
                fill={color}
                d="M29.2,2.9c0,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0,0-0.1-0.1-0.2-0.2C29.2,2.8,29.1,2.9,29.2,2.9z"
            />
            <path
                fill={color}
                d="M20,2.5c0.1,0,0.2-0.1,0.2-0.1c0,0,0-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.1C19.9,2.4,20,2.4,20,2.5z"
            />
            <path
                fill={color}
                d="M19.1,2.2c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1c0,0,0.1,0.1,0.1,0.1C19,2.3,19.1,2.2,19.1,2.2z"
            />
            <path
                fill={color}
                d="M21,3c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.1C20.9,3,21,3,21,3z"
            />
        </g>
        <g>
            <path
                fill={color}
                d="M118.7,3.2c-0.1-0.1-0.3-0.4-0.3-0.4c-0.2,0.2-0.3,0-0.4-0.2c-0.2-0.6-0.6-0.2-0.9-0.4c-0.4,0.9-0.7,0-1.1,0.1
		c-0.2,0.1-0.5,0.4-0.7,0.3c-0.6-0.4-1.1-0.3-1.7-0.2c-0.4,0.1-0.6-0.1-0.8-0.5c-0.1,0.5-0.1,0.8-0.2,1.3c-0.7-1-1.4-1-2.2-0.6
		c-0.2-0.2-0.3-0.4-0.4-0.6c-0.2,0.2-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.5,0.4c-0.1-0.2-0.1-0.5-0.2-0.5c-0.5,0.1-0.9,0.4-1.2,0.3
		c-0.6-0.3-1.2-0.1-1.8,0c-0.6,0.1-1.3,0.5-1.7-0.3c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.5-0.2-0.7-0.3c-0.1,0.5-0.4,0.7-0.8,0.5
		c-0.2-0.1-0.5-0.3-0.7-0.4c-0.4-0.1-0.8-0.2-0.9,0.5c-0.3-0.3-0.6-0.5-0.9-0.8c-0.2,0.3-0.3,0.5-0.5,0.8C99,2.4,99,2.2,98.9,2
		c-0.4,0-0.7-0.1-0.6,0.6c-0.3,0-0.5,0-0.7,0c-0.2,0-0.4,0.1-0.5,0.1c-0.4-0.2-0.8-0.6-1.3,0c0,0-0.1,0-0.2,0
		c-0.3-0.3-0.7-0.1-1-0.2c-0.2,0-0.3-0.2-0.5-0.4c-0.5,0.4-0.5,0.4-1.7,0c0,0.2,0,0.4-0.1,0.7c-0.8-0.3-1.6-0.7-2.5-0.1
		c-0.6-0.4-1.4,0.5-1.8-0.4c-0.3,0.2-0.5,0.3-0.8,0.4C87.3,2.4,87.2,2.2,87,2c-0.1,0.3-0.2,0.5-0.2,0.5c-0.5-0.1-0.8-0.2-1.2-0.2
		c-0.4,0.1-0.8,0.2-1.1-0.2C84.3,2,84.2,2,84,1.9c0,0.3-0.1,0.5-0.1,0.9c-0.4-0.2-0.8-0.4-1.2-0.6c0,0-0.1,0-0.2,0.1
		c-0.2,0.2-0.4,0.4-0.6,0.7c-0.1-0.1-0.1-0.3-0.2-0.5c-0.3,0.1-0.5,0.3-0.7,0.2c-0.2,0-0.3-0.3-0.4-0.5c-0.3,0.2-0.6,0.5-0.8,0.4
		c-1-0.2-2.1,0-3.1-0.3c-0.1,0-0.3-0.1-0.4,0c-0.7,0.8-1.4-0.1-2,0.2c-0.5-0.8-0.8-0.1-1.1,0.4c-0.4-0.6-0.8-0.9-1.3-0.3
		c-0.1,0.1-0.2,0.1-0.3,0.1c-0.5-0.3-0.9,0.1-1.3,0.6C70.1,2.9,70,2.6,70,2.6c-0.6,0.2-1.2-0.1-1.8-0.1c-0.8,0-1.5,0.5-2.3,0.1
		c-0.5,0.4-0.9,0-1.3-0.2c-0.2-0.1-0.4-0.2-0.5-0.1c-0.4,0.9-0.8,0.2-1.1-0.1c-0.7,0.5-0.8,0.5-0.9-0.5c-0.2,0.4-0.4,0.7-0.5,1.1
		c-0.4-0.8-1.2,0.2-1.6-0.6c-0.1,0.3-0.2,0.6-0.3,0.9c-0.4-0.4-0.7-0.7-1-1.1c-0.6,0.7-1.2,0-1.8,0.2c0,0.2,0,0.3,0,0.5
		c-0.6,0.2-1,0-1.3-0.7c-0.3,0.1-0.6,0.9-1,0.5c-0.6-0.5-0.6,0.2-0.9,0.6c-0.3-0.4-0.5-1.2-1-0.3c-0.2-0.3-0.3-0.6-0.4-0.8
		c-0.3,0.2-0.5,0.4-0.7,0.5c-0.1-0.2-0.2-0.3-0.2-0.4c-0.3,0.2-0.6,0.4-0.9,0.6c-0.1-0.2-0.2-0.4-0.3-0.6c-0.2,0.3-0.3,0.5-0.6,0.9
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.5,0.6-1.1,0.8-1.6,0.5c-0.7-0.4-1.4-0.2-2,0.1c-0.3-0.1-0.6-0.1-0.9-0.2c-0.4-0.3-0.5,0.6-0.8,0.3
		c-0.1-0.2-0.3-0.5-0.4-0.7c-0.3,0.3-0.5,0.6-0.8,0.8c-0.4-0.2-0.7-0.5-1-0.7c-0.1,0.2-0.2,0.4-0.3,0.6c-0.2,0-0.3-0.1-0.5-0.1
		c-0.2,0-0.4,0-0.6-0.1c-0.4-0.1-0.8-0.5-1.1,0.2C38.6,2.4,38,3,37.6,2.4c-0.2-0.2-0.4-0.3-0.5,0.1c-0.1,0.4-0.3,0.3-0.5,0.4
		c-0.1,0-0.2,0.2-0.4,0.4C36.1,3.2,36,3.1,36,2.9c-0.1-0.1-0.2-0.3-0.2-0.3c-0.2,0.1-0.3,0.2-0.4,0.2c-0.3-0.1-0.6-0.2-0.9-0.3
		c-0.5-0.1-0.8,0.1-1,0.9c0,0.1-0.1,0.1-0.2,0.1c0-0.4,0-0.7,0-1.2c-0.3,0.1-0.5,0.2-0.7,0.2c-0.2,0-0.4,0.2-0.5,0.1
		C32,2.6,32,2.3,31.8,1.9c-0.3,0.3-0.5,0.6-0.8,0.9c-0.3-0.1-0.6-0.1-0.9-0.2C29.4,2.2,29.4,2.2,29,3c-0.3-0.6-0.7-0.7-1.1-0.5
		c-0.3,0.2-0.6,0.1-0.9,0.1c-0.4-0.1-0.8-0.2-1.2,0.1c-0.3,0.2-0.5,0-0.7-0.1c-0.4-0.3-0.6-0.1-0.7,0.4c-0.8,0.4-1.4-0.6-2.2-0.7
		c0.1,0.3,0.1,0.5,0.2,0.7c-0.6,0.2-0.9-0.2-1.1-0.8c-0.4,0.4-0.5,0.4-1,0.3c-0.1,0-0.2,0-0.2,0.1c-0.3,0.6-0.6,0.3-0.9,0
		c-0.1-0.1-0.5-0.1-0.6,0C18.5,3,18.1,2.7,18,2.8c-0.4,0.6-0.6-0.2-0.9-0.1c-0.3,0.1-0.6,0.4-1-0.1c-0.2-0.2-0.7-0.1-1.1,0.1
		c-0.5,0.2-0.8-0.2-1.2-0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.3-0.3-0.5-0.5-0.8-0.8c-0.3,1-0.8,0.8-1.3,0.5c-0.2-0.1-0.4-0.2-0.7-0.3
		C11,2.5,11,2.7,11.1,3c-0.4-0.1-0.8-0.1-0.9-0.3C9.8,2.1,9.6,2.3,9.1,2.7C8.7,3,8.1,3,7.7,3C7.4,3,7.2,2.6,7,2.3
		C6.6,2.9,6.2,3.1,5.9,3c-0.5-0.3-1.5-0.3-2-0.1C3.6,3,3.3,2.9,3.2,2.3c0-0.1-0.1-0.1-0.2-0.2c0,0.2,0,0.4,0,0.6
		C2.3,2.6,1.7,2.5,1.3,2.4C1,2.8,0.8,3,0.6,3.2C0.4,3.5,0,3.8,0,4.2l0.7,0.6c0.4,0.1,1.1,0.2,1.7,0.3c0-0.2,0-0.4,0-0.7
		c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0.6,0.4,0.7,0.8,0.5c0.2-0.1,0.5-0.1,0.8-0.1c0,0,0.1,0,0.2,0c0,0,0,0,0,0.1c0.4,0,0.8,0.1,1.1,0.2
		c0.3,0.2,0.7,0,1.1-0.6c0.2,0.2,0.5,0.7,0.7,0.7c0.5,0,1.1,0,1.5-0.3C9.3,4.7,9.5,4.4,10,5.1c0.1,0.2,0.6,0.2,0.9,0.3
		c-0.1-0.3-0.1-0.5-0.2-0.9c0.3,0.1,0.5,0.2,0.7,0.3c0.5,0.3,1,0.5,1.3-0.5c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0-0.1,0.1-0.1,0.2-0.3
		c0,0.2,0.1,0.4,0.1,0.5c0,0,0,0,0,0c0.1,0.1,0.3,0.3,0.5,0.5c0.1-0.2,0.2-0.4,0.3-0.6C14.2,4.8,14.6,5.2,15,5
		c0.4-0.1,0.9-0.3,1.1-0.1c0.4,0.5,0.7,0.2,1,0.1c0.3-0.1,0.5,0.7,0.9,0.1c0.1-0.1,0.5,0.2,0.6-0.4c0,0,0.1,0,0.2-0.1
		c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.1-0.1,0.3c0.1,0,0.3,0,0.3,0.1
		c0.3,0.3,0.6,0.6,0.9,0c0-0.1,0.2-0.1,0.2-0.1c0.6,0.1,0.7,0.1,1.1-0.3c0.2,0.6,0.5,1.1,1.2,0.8c-0.1-0.2-0.1-0.4-0.2-0.7
		c0.8,0.1,1.4,1.1,2.3,0.7c0.1-0.5,0.3-0.7,0.7-0.4C25.7,5,25.9,5.2,26.2,5c0.4-0.3,0.8-0.2,1.2-0.1c0.3,0,0.6,0.1,0.9-0.1
		c0.4-0.2,0.8-0.1,1.1,0.5c0.4-0.8,0.4-0.8,1.2-0.4c0.3,0.1,0.6,0.2,0.9,0.3c0.3-0.3,0.6-0.6,0.8-0.9c0.1,0.4,0.2,0.7,0.3,0.8
		C32.8,5.2,33,5,33.1,5c0.2-0.1,0.4-0.1,0.7-0.2c0,0.5,0,0.8,0,1.2C33.9,5.9,34,5.9,34,5.8c0.2-0.8,0.4-1.1,1-0.9
		c0.3,0.1,0.6,0.3,1,0.3c0.1,0,0.3-0.1,0.4-0.2c0,0,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.2-0.4,0.4-0.4
		c0.2,0,0.4,0,0.5-0.4c0.1-0.4,0.3-0.4,0.5-0.1c0.4,0.6,1.1,0,1.5,0.5C40.1,4.4,40.6,4.8,41,5C41.2,5,41.4,5,41.6,5
		c0.2,0,0.3,0.1,0.5,0.1c0.1-0.2,0.2-0.4,0.3-0.6c0.4,0.2,0.7,0.5,1.1,0.7c0.2-0.3,0.5-0.5,0.8-0.9c0.2,0.3,0.3,0.5,0.5,0.7
		c0.4,0.3,0.4-0.6,0.8-0.3c0.3,0.2,0.6,0.2,0.9,0.2c0.6-0.3,1.3-0.5,2-0.1c0.5,0.3,1.1,0.1,1.6-0.5c0.1,0.3,0.2,0.6,0.3,0.9
		c0.3-0.4,0.4-0.6,0.6-0.9c0.1,0.3,0.2,0.4,0.3,0.6c0.3-0.2,0.6-0.4,0.9-0.6c0,0.1,0.1,0.3,0.2,0.5c0.2-0.1,0.4-0.3,0.8-0.5
		c0.1,0.3,0.3,0.5,0.4,0.9c0,0,0,0,0,0c-0.1-0.3,0-0.6,0-1c0.1,0.2,0.1,0.4,0.2,0.7c0.4-0.3,0.5,0.4,0.8,0.7
		c0.3-0.4,0.3-1.2,0.9-0.6c0.5,0.4,0.7-0.4,1-0.5c0.3,0.7,0.8,0.9,1.3,0.7c0-0.2,0-0.3,0-0.5c0.6-0.2,1.3,0.6,1.9-0.2
		c0.4,0.4,0.7,0.7,1.1,1.1c0.1-0.3,0.2-0.6,0.3-1c0.5,0.8,1.2-0.2,1.7,0.6c0.2-0.4,0.4-0.7,0.6-1.2c0.1,1,0.2,1.1,0.9,0.6
		c0.4,0.2,0.7,1,1.2,0.1c0-0.1,0.3,0,0.5,0.1c0.4,0.2,0.7,0.4,1.1,0.3c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1
		c0.8,0.4,1.6-0.1,2.4-0.1c0.6,0,1.2,0.3,1.9,0.1c0,0,0.1,0.3,0.2,0.6c0.4-0.5,0.8-0.9,1.3-0.6c0.1,0,0.3,0,0.3-0.1
		c0.5-0.6,0.9-0.3,1.3,0.4c0.3-0.5,0.6-1.2,1.1-0.4c0.7-0.3,1.4,0.6,2.1-0.2c0.1-0.1,0.3,0,0.4,0C79.9,5,81,4.8,82.1,5
		c0.2,0,0.5-0.3,0.8-0.4C83,4.7,83.2,5,83.3,5c0.2,0,0.5-0.1,0.7-0.2c0.1,0.2,0.2,0.4,0.2,0.5c0.2-0.2,0.4-0.5,0.6-0.7
		c0,0,0.1-0.1,0.2-0.1c0.4,0.2,0.8,0.4,1.2,0.6c0-0.4,0.1-0.6,0.1-0.9c0.2,0.1,0.3,0.1,0.4,0.2c0.4,0.4,0.7,0.3,1.2,0.2
		c0.4-0.1,0.7,0.1,1.2,0.2c0,0,0.1-0.3,0.2-0.6C89.7,4.6,89.8,4.8,90,5c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.1-0.1-0.2
		c0.2,0,0.3,0.1,0.4,0.1c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0.1,0.1,0.1,0.1c-0.1-0.4,0-0.6,0.4-0.8c0,0.3,0,0.6,0.1,0.9
		c-0.2,0-0.3,0-0.4-0.1C91.3,5.3,92,4.6,92.6,5c0.9-0.6,1.7-0.2,2.6,0.1c0-0.2,0-0.5,0.1-0.7c1.2,0.4,1.2,0.4,1.7,0
		c0.2,0.1,0.3,0.3,0.5,0.4c0.3,0.1,0.7-0.2,1,0.2c0,0,0.1,0,0.2,0c0.5-0.6,0.9-0.2,1.3,0c0.1,0.1,0.3-0.1,0.5-0.1c0.2,0,0.5,0,0.7,0
		c0-0.7,0.3-0.6,0.7-0.6c0.1,0.2,0.1,0.5,0.2,0.8c0.2-0.3,0.4-0.6,0.6-0.9c0.3,0.3,0.6,0.5,0.9,0.8c0.1-0.7,0.5-0.6,0.9-0.5
		c0.3,0.1,0.5,0.2,0.8,0.4c0.4,0.2,0.6,0,0.8-0.5c0.2,0.1,0.5,0.3,0.7,0.3c0.2,0,0.4-0.1,0.7-0.2c0.4,0.8,1.1,0.4,1.8,0.3
		c0.6-0.1,1.2-0.3,1.8,0c0.3,0.2,0.7-0.2,1.2-0.3c0,0,0.1,0.2,0.2,0.5c0.3-0.2,0.4-0.3,0.5-0.4c0.1-0.1,0.2-0.2,0.4-0.4
		c0.1,0.2,0.3,0.4,0.4,0.6c0.8-0.5,1.6-0.5,2.3,0.6c0.1-0.5,0.2-0.8,0.2-1.3c0.2,0.5,0.4,0.6,0.8,0.6c0.6-0.1,1.2-0.2,1.8,0.2
		c0.2,0.1,0.5-0.1,0.7-0.3c0.1,0,0.3,0.1,0.4,0.2c0-0.1,0-0.2,0-0.3c0-0.6-0.2-1-0.6-1.2c-0.1-0.1-0.3-0.3-0.4-0.3
		C118.9,2.9,118.8,3.2,118.7,3.2z M4.8,4.4C4.4,4.6,4.2,4.5,4.3,3.7C4.6,4.1,4.7,4.2,4.8,4.4z M7,3.4c-0.1,0-0.1-0.1-0.2-0.1
		c0-0.1,0.1-0.2,0.2-0.3C7,3.1,7.1,3.2,7.1,3.3C7.1,3.3,7,3.4,7,3.4z M9.8,4.4c0,0-0.1,0-0.1,0c0-0.2,0-0.3,0-0.5c0.1,0,0.1,0,0.2,0
		C9.9,4.1,9.9,4.2,9.8,4.4z M11.9,4.1c-0.1-0.5-0.1-0.5,0.4-0.6C12.2,3.8,12.1,3.9,11.9,4.1z M20.1,4.9C20.1,5,20,5,19.9,5.1
		c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.2,0.2-0.3C20,4.7,20.1,4.8,20.1,4.9z M21.1,3.4c-0.1,0-0.1-0.1-0.2-0.2C21,3.1,21,3,21.1,2.9
		c0.1,0.1,0.1,0.2,0.2,0.3C21.3,3.3,21.2,3.4,21.1,3.4z M24.9,4.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.1-0.1-0.1-0.2
		c0-0.1,0.1-0.2,0.1-0.3C24.8,4.3,24.9,4.4,24.9,4.4z M53.9,4.2c-0.3,0.2-0.4,0-0.3-0.6C53.8,3.9,53.8,4,53.9,4.2z M68.9,3.8
		c0.1-0.4,0.3-0.7,0.7-0.5C69.4,3.7,69.3,4.1,68.9,3.8z"
            />
            <path fill={color} d="M55.2,6.6c-0.1-0.2-0.2-0.3-0.4-0.7C54.8,6.6,54.9,6.8,55.2,6.6z" />
            <path fill={color} d="M70.7,6.2c0.5,0.3,0.5-0.2,0.7-0.5C71,5.5,70.8,5.8,70.7,6.2z" />
            <path
                fill={color}
                d="M12.8,7.2c0.1,0,0.2-0.1,0.2-0.1c0-0.1,0-0.3-0.1-0.5c-0.1,0.2-0.2,0.2-0.2,0.3C12.7,7,12.7,7.1,12.8,7.2z"
            />
            <path fill={color} d="M11.7,6.5c0.1-0.2,0.2-0.4,0.4-0.6C11.6,6,11.6,6,11.7,6.5z" />
            <path
                fill={color}
                d="M9.4,6.8c0.1,0,0.1,0,0.1,0c0-0.2,0-0.3,0-0.5c-0.1,0-0.1,0-0.2,0C9.4,6.5,9.4,6.6,9.4,6.8z"
            />
            <path
                fill={color}
                d="M6.4,5.7c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.2-0.2C6.7,5.6,6.6,5.5,6.6,5.4C6.5,5.5,6.4,5.6,6.4,5.7z"
            />
            <path
                fill={color}
                d="M21,5.5c0.1,0.1,0.1,0.2,0.2,0.2c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.3C21.2,5.4,21.1,5.5,21,5.5z"
            />
            <path
                fill={color}
                d="M24.9,6.9C24.9,7,25,7.1,25,7.1c0-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.1-0.1-0.2-0.2C25,6.7,24.9,6.8,24.9,6.9z"
            />
            <path
                fill={color}
                d="M29.2,8.6c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.6C29.2,8.4,29.1,8.5,29.2,8.6z"
            />
            <path
                fill={color}
                d="M20,7.5c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1,0-0.2-0.1-0.4c-0.1,0.1-0.2,0.2-0.2,0.3C19.9,7.3,20,7.4,20,7.5z"
            />
            <path
                fill={color}
                d="M19.1,6.9c0-0.1-0.1-0.2-0.1-0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.2,0.1,0.3C19,7.1,19.1,7,19.1,6.9z"
            />
            <path
                fill={color}
                d="M21,8.8c0.1,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.1,0.2-0.2,0.3C20.9,8.7,21,8.8,21,8.8z"
            />
        </g>
    </svg>
);

TitleSmallDouble.propTypes = propTypes;
TitleSmallDouble.defaultProps = defaultProps;

export default TitleSmallDouble;
